import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ClearDiv } from '../../components/common';
import ManageSurveyDimensions from '../../components/pages/manage-survey-dimensions/ManageSurveyDimensions';
import { AdminReopenSurvey } from '../../components/pages/survey-admin/AdminReopenSurvey';
import { AdminEditSurvey } from '../../components/pages/survey-admin/edit-survey';
import Constants from '../../constants';
import ContentConstants from '../../contentConstants';
import { AdminAnonymityThresholdPage } from '../pages/AdminAnonymityThresholdPage';
import { AdminBenchmarksPage } from '../pages/AdminBenchmarksPage';
import { AdminMenuPage } from '../pages/AdminMenuPage';
import { AdminReportingAccessPage } from '../pages/AdminReportingAccessPage';
import { AdminSurveyOverviewPage } from '../pages/AdminSurveyOverviewPage';
import { AdminTrendToPage } from '../pages/AdminTrendToPage';
import { AudienceLoaderContainer } from '../pages/AudienceLoaderContainer';
import { ReportingProfilesPage } from '../pages/ReportingProfilesPage';
import { SurveyAdminSummaryLoaderContainer } from '../pages/SurveyAdminSummaryLoaderContainer';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';
import { AdminLayoutContainer } from './AdminLayout';
import { BreadcrumbContainer } from './BreadcrumbContainer';
import { actionCreators } from './LayoutStore';

export class AdminRouter extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		const surveyId = parseInt(this.props.match.params.surveyId, 10);

		return (
			<>
				<SurveyAdminSummaryLoaderContainer surveyId={surveyId} {...this.props} />
				<AudienceLoaderContainer surveyId={surveyId} {...this.props} />
				<AdminLayoutContainer {...this.props} {...actionCreators}>
					<BreadcrumbContainer {...this.props} />
					<ClearDiv clearHeight={'30px'} />
					<Switch>
						<Route exact={true} path='/survey-admin/:surveyId' component={() => <AdminMenuPage surveyId={surveyId} />} />
						<Route
							exact
							path={`${Constants.ROUTE_SURVEY_ADMIN}/:surveyId/${Constants.SUBROUTE_SURVEY_ADMIN_EDIT_SURVEY}`}
							render={() => <AdminEditSurvey surveyId={surveyId} />}
						/>
						<Route exact={true} path='/survey-admin/:surveyId/benchmarks' component={() => <AdminBenchmarksPage surveyId={surveyId} />} />
						<Route exact={true} path='/survey-admin/:surveyId/survey-overview' component={AdminSurveyOverviewPage} />
						<Route
							exact={true}
							path='/survey-admin/:surveyId/reporting-access'
							component={() => <AdminReportingAccessPage surveyId={surveyId} />}
						/>
						<Route exact={true} path='/survey-admin/:surveyId/trend-to' component={() => <AdminTrendToPage surveyId={surveyId} />} />
						<Route
							exact={true}
							path='/survey-admin/:surveyId/manage-dimensions'
							render={() => <ManageSurveyDimensions pageTitle={ContentConstants.SECTION_HEADERS_MANAGE_DIMENSIONS} />}
						/>
						<Route
							exact={true}
							path={'/survey-admin/:surveyId/' + Constants.SUBROUTE_SURVEY_ADMIN_ANONYMITY_THRESHOLD}
							component={() => <AdminAnonymityThresholdPage surveyId={surveyId} />}
						/>
						<Route
							exact={true}
							path={'/survey-admin/:surveyId/' + Constants.SUBROUTE_SURVEY_ADMIN_REPORTING_PROFILES}
							component={() => <ReportingProfilesPage surveyId={surveyId} />}
						/>
						<Route
							exact={true}
							path={'/survey-admin/:surveyId/' + Constants.SUBROUTE_SURVEY_ADMIN_REOPEN_SURVEY}
							component={() => <AdminReopenSurvey isUpdatingAtSurveyLevel={true} />}
						/>
					</Switch>
				</AdminLayoutContainer>
			</>
		);
	}
}
